import { colors, ORDER_ISSUE_TYPES } from '@nandosaus/constants';
import { concat, find, findLastIndex, isEmpty, map, reject } from 'lodash';
import { useRootStore } from '@nandosaus/state-management';
import { useState } from 'react';

import { Box, Flex } from '../../grid';
import { Button } from '../../button';
import { InputListItem } from '../../input-list-item';
import { Label, P } from '../../typography';

const SUBHEADER = {
  [ORDER_ISSUE_TYPES.WRONG_OR_MISSING_ITEM]: (
    <P variant={3} mb={1}>
      Which item(s) had an issue?
    </P>
  ),
  [ORDER_ISSUE_TYPES.QUALITY]: (
    <P variant={3} mb={1}>
      Oh no! We&#39;re sorry to hear that. Which item(s) had an issue?
    </P>
  ),
  [ORDER_ISSUE_TYPES.DIETARY_REQUIREMENTS_NOT_MET]: (
    <>
      <P variant={3} mb={1}>
        We&#39;re so sorry to hear that. Dietary needs are no joke and we want everyone to feel safe ordering their
        Nando&#39;s fix.
      </P>
      <P variant={3} mb={1}>
        Can you tell us which item(s) had an issue?
      </P>
    </>
  ),
};

const SelectOrderItems = () => {
  const { OrderHelpStore, MemberStore } = useRootStore();
  const [listOrderItems, setListOrderItems] = useState([]);
  const order = OrderHelpStore.orderWithRefundableChoice;

  const products = order.orderItems;
  const handleSubmit = () => {
    const orderItemUuids = map(listOrderItems, 'uuid');
    OrderHelpStore.setOrderItemUuids(orderItemUuids);
    OrderHelpStore.goForward();
  };
  const isGuestFlow = !MemberStore.isSignedIn;

  return (
    <>
      {SUBHEADER[OrderHelpStore.orderIssue]}
      <Box>
        <Flex
          flexDirection="column"
          backgroundColor="white"
          borderTop={isGuestFlow ? `1px solid ${colors.grey100}` : ''}
        >
          {map(products, (product, index) => {
            const showBorder = isGuestFlow ? true : index !== findLastIndex(products);
            const listOrderItem = {
              listId: `${index}#${product.uuid}`,
              uuid: product.uuid,
            };

            return (
              <Flex
                py={1}
                ml={isGuestFlow ? 0 : 1}
                borderBottom={showBorder ? `solid 1px ${colors.grey100}` : 0}
                key={index}
              >
                <InputListItem
                  key={index}
                  type="checkbox"
                  name={listOrderItem.listId}
                  label=""
                  selected={!!find(listOrderItems, { listId: listOrderItem.listId })}
                  onSelect={() => {
                    const updatedListOrderItems = find(listOrderItems, { listId: listOrderItem.listId })
                      ? reject(listOrderItems, { listId: listOrderItem.listId })
                      : concat(listOrderItems, listOrderItem);
                    setListOrderItems(updatedListOrderItems);
                  }}
                  py="0"
                >
                  <Flex flexDirection="column">
                    <P variant={2}>{product.name}</P>
                    <Label variant={2}>{product.choicesLabel}</Label>
                  </Flex>
                </InputListItem>
              </Flex>
            );
          })}
        </Flex>
        <Button mt={1} disabled={isEmpty(listOrderItems)} name="next" onClick={handleSubmit}>
          next
        </Button>
      </Box>
    </>
  );
};

export { SelectOrderItems };
